import Vue from 'vue'
import Vuex from 'vuex'
import offer from './modules/offer'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    offer,
  },
  strict: debug,
})